import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { AreaService } from 'src/app/_services/area.service';
import { CityService } from 'src/app/_services/city.service';
import { PspTasksService } from 'src/app/_services/PSP/psp-tasks.service';
import { PspProgramsService } from 'src/app/_services/PSP/psp-programs.service';
import { PSPProgram } from 'src/app/_models/PSP/psp-program-model';
import { PSPPatient } from 'src/app/_models/PSP/psp-patient.model';
import { PatientSubscribeToPSP } from 'src/app/_models/PSP/psp-new-patient-sub.model';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LookupModalService } from 'src/app/_services/PSP/modals.service';
import { PatientService } from 'src/app/_services/patient.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Area } from 'src/app/_models/area.model';
import { City } from 'src/app/_models/city.model';
import { CompanyService } from 'src/app/_services/company.service';
import { IsPermissionExist } from 'src/app/helpers/get-permissions';
import { PspEvaPermission, PspLillyPermission, PspRochePermission } from 'src/app/_constants/permissions.constant';
import {
  FullPatient,
  IPersonalInfo,
  PatientAddress,
} from 'src/app/_models/patient.model';
import { NationalIdValidator } from 'src/app/shared/nationalId-validator';
import { NameValidator } from 'src/app/shared/name-validator';
import { DoctorHospitalValidator } from 'src/app/shared/doctor-hospital-validator';
import { PatientIdsValidator } from 'src/app/shared/patient-ids-validator';
import { PatientScreenTypeEnum } from 'src/app/enums/patient-screen-enum';
import { PspCompanyEnum } from '../../../enums/psp-company.enum';
import { RocheDoctor } from '../../../_models/PSP/psp-RocheDoctor.model';
import { DoctorsService } from '../../../_services/doctors.service';
import { InsulinType, InsulinCenter } from 'src/app/_models/PSP/psp-insulin.model';
import { PspInsulinService } from 'src/app/_services/PSP/psp-insulin.service';

@Component({
  selector: 'app-enroll-to-another-program',
  templateUrl: './enroll-to-another-program.component.html',
  styleUrls: ['./enroll-to-another-program.component.scss'],
})
export class EnrollToAnotherProgramComponent implements OnInit {
  programList: PSPProgram[];
  user = {} as PSPPatient;

  newPatient = {} as PatientSubscribeToPSP;

  patient = {} as FullPatient;
  notificationModal: BsModalRef;
  newAddress = {} as PatientAddress;
  cityList: City[];
  areaList: Area[];
  patientId: number;
  companies = [];
  companyId?: number = null;
  specialtyId?: number = null;
  patientPersonalInfo: IPersonalInfo;
  patientFullName: string = null;
  patientNationalId: string = null;
  patientPassportId: string = null;
  patientDateOfBirth: string | Date = null;
  patientPhone: string = null;
  patientCity: number = null;
  patientArea: number = null;
  enrollToAnotherProgramForm: FormGroup;
  rocheDoctors: RocheDoctor[] = [];
  // TODO: extract into an api
  rocheTypes = [
    { id: 'A', name: 'HCP' },
    { id: 'C', name: 'Private Hospital' },
    { id: 'D', name: 'Cleopatra Group' },
    { id: 'N', name: 'NGO' }
  ];

  readonly Number = Number;

  serialNumbersByType: any[];
  displayErrorInSubscriptionHistory = false;
  insulinTypes?: InsulinType[];
  referralCenters?: InsulinCenter[];
  uploadFileTypes: string = ".jpg, .jpeg, .png, .gif, .pdf";
  uploadedDocuments: File[] = [];
  maxDocumentsToUpload = 10;

  constructor(
    private formBuilder: FormBuilder,
    private pspTaskService: PspTasksService,
    private router: Router,
    private areaService: AreaService,
    private cityService: CityService,
    private spinner: NgxSpinnerService,
    private companyService: CompanyService,
    private toastr: ToastrService,
    private programService: PspProgramsService,
    private patientService: PatientService,
    private activatedRoute: ActivatedRoute,
    private DoctorService: DoctorsService,
    private pspInsulinService: PspInsulinService
  ) { }

  ngOnInit(): void {
    this.enrollToAnotherProgramForm = this.createEnrollToAnotherProgramForm();

    this.patientId = this.activatedRoute.snapshot.params.patientId;

    this.enrollToAnotherProgramForm
      .get('patientIds.patientNationalId')
      .valueChanges
      .subscribe((response) => {
        if (response) {
          this.enrollToAnotherProgramForm
            .get('patientIds.patientPassportId')
            .setValue(null);
        }
      });

    this.enrollToAnotherProgramForm
      .get('patientIds.patientPassportId')
      .valueChanges
      .subscribe((response) => {
        if (response) {
          this.enrollToAnotherProgramForm
            .get('patientIds.patientNationalId')
            .setValue(null);
        }
      });

    this.getAllCities();

    this.companyService.getAllCompanies().subscribe((response) => {
      this.companies = response.data?.companies.filter(c => this.hasCompanyPermission(c.id));
    });
  }

  createEnrollToAnotherProgramForm(): any {
    return this.formBuilder.group({
      patientFullName: [null, [Validators.required, NameValidator]],
      patientProgramId: [{ value: null, disabled: true }, Validators.required],
      patientIds: this.formBuilder.group(
        {
          isPassportId: [false],
          patientNationalId: [null, [NationalIdValidator]],
          patientPassportId: [null],
        }, { validator: PatientIdsValidator }
      ),
      companyId: [null, Validators.required],
      patientDateOfBirth: [null, Validators.required],
      patientMobileNumber: [
        null,
        [Validators.required, Validators.pattern('(01)[0-9]{9}')],
      ],
      patientCityId: [null, Validators.required],
      patientAreaId: [null, Validators.required],
      physicianDetails: this.formBuilder.group({
        doctorName: [null],
        hospitalName: [null, [Validators.minLength(3)]],
        rocheType: [null],
        serialNumber: [null],
      }, {
        validator: this.physicianDetailsValidator
      }),
      subscriptionHistory: [null, [Validators.maxLength(50)]],
      referralCenterId: [null],
      insulinTypeId: [null]
    });
  }

  getPatientInfo(): void {
    this.patientService.getPateintById(this.patientId).subscribe((response) => {
      this.patientPersonalInfo = response?.data?.personalInfo;

      this.patientFullName = this.patientPersonalInfo.fullName;
      this.patientPassportId = this.patientPersonalInfo.passportId;
      this.patientNationalId = this.patientPersonalInfo.nationalId;
      this.patientDateOfBirth = this.patientPersonalInfo.birthdate?.toString()?.split('T')[0];
      this.patientCity = this.patientPersonalInfo.cityId;
      this.patientArea = this.patientPersonalInfo.areaId;
      this.patientPhone = this.patientPersonalInfo.phone;

      const valuesToPatch = {
        patientFullName: this.patientFullName,
        patientIds: {},
        patientDateOfBirth: this.patientDateOfBirth,
        patientCityId: this.patientCity,
        patientAreaId: this.patientArea,
        patientMobileNumber: this.patientPhone,
      };

      if (this.patientPassportId) {
        // @ts-ignore
        valuesToPatch.patientIds.patientPassportId = this.patientPassportId;
      }

      if (this.patientNationalId) {
        // @ts-ignore
        valuesToPatch.patientIds.patientNationalId = this.patientNationalId;
      }

      this.enrollToAnotherProgramForm.patchValue(valuesToPatch);

      if (this.patientCity) {
        this.onCityChange(this.patientCity);
      }

      this.enrollToAnotherProgramForm.get('patientIds').updateValueAndValidity();

      this.setFieldsDisable();
    });
  }

  setFieldsDisable(): void {
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientFullName')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientDateOfBirth')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientCityId')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientAreaId')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientMobileNumber')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientIds.patientNationalId')
    );
    this.isControlDisabled(
      this.enrollToAnotherProgramForm.get('patientIds.patientPassportId')
    );

    if (
      this.enrollToAnotherProgramForm.get('patientIds.patientNationalId').value
      || this.enrollToAnotherProgramForm.get('patientIds.patientPassportId').value
    ) {
      this.enrollToAnotherProgramForm.get('patientIds.isPassportId').disable();
    }

    if (
      this.enrollToAnotherProgramForm.get('patientIds.patientNationalId').value
    ) {
      this.enrollToAnotherProgramForm
        .get('patientIds.isPassportId')
        .setValue(false);
    } else {
      this.enrollToAnotherProgramForm
        .get('patientIds.isPassportId')
        .setValue(true);
    }
  }

  isControlDisabled(control: AbstractControl): void {
    if (control.value) {
      control.disable();
    }
  }

  getAllCities(): void {
    this.cityService.getAllCities().subscribe((response) => {
      this.cityList = response;

      this.getPatientInfo();
    });
  }

  onCityChange(cityId): void {
    this.areaService.getAreasByCityId(cityId).subscribe((response) => {
      this.areaList = response.data?.areas;
    });
  }
  
  onCompanyChange(event: any): void {
    this.spinner.show();

    this.enrollToAnotherProgramForm.patchValue({
      subscriptionHistory: null,
      physicianDetails: {
        rocheType: null,
        serialNumber: null,
      }
    });

    this.serialNumbersByType = [];

    this.companyId = Number.parseInt(event, 10);

    this.programService
      .getAllProgramsByCompanyId(this.companyId)
      .subscribe((res) => {
        this.programList = [...res.data.programs];
      });


    this.enrollToAnotherProgramForm.get('patientProgramId').reset();
    this.enrollToAnotherProgramForm.get('patientProgramId').enable();

    if (this.companyId === PspCompanyEnum.Roche) {
      this.enrollToAnotherProgramForm.patchValue({
        physicianDetails: {
          doctorName: null,
          hospitalName: null,
        }
      });
      this.enrollToAnotherProgramForm.get('physicianDetails.doctorName').reset();
      this.DoctorService
        .getDoctorsByCompanyId(this.companyId)
        .subscribe((res) => {
          this.rocheDoctors = res.data.doctors;
        });
    }

    if(this.companyId === PspCompanyEnum.Eva){
      this.pspInsulinService.getInsulinTypes().subscribe((res) => {
        this.insulinTypes = res.data;
      });
    }
  }

  onCopy(): void {
    const copyText = this.enrollToAnotherProgramForm.value.patientMobileNumber;
    navigator.clipboard.writeText(copyText);

    showNotification(
      'success',
      'The Phone Number Has Been Copied Successfully.',
      this.toastr
    );
  }


  onEnrollToAnotherProgram(): void {
    const formValue = this.enrollToAnotherProgramForm.getRawValue();

    let responseData= this.changeResponseToFormData(formValue);

    this.pspTaskService.addNewPatient(responseData).subscribe((res) => {
      showNotification(
        'success',
        `${this.patientFullName} successfully subscribed to another program.`,
        this.toastr
      );
      this.patientService.setPatientScreenType(PatientScreenTypeEnum.PspPatients);
      this.router.navigateByUrl('patient-details/' + this.patientId);
    });
  }

  onReset(): void {
    this.patientService.isPspSection.next(true);
    this.enrollToAnotherProgramForm.reset();
    this.router.navigateByUrl('patient-details/' + this.patientId);
  }

  physicianDetailsValidator(control: AbstractControl): ValidationErrors | null {
    const doctorNameControl = control.get('doctorName');

    const rochTypeControl = control.get('rocheType');
    const serialNumberControl = control.get('serialNumber');

    if (rochTypeControl.value?.trim() && serialNumberControl.value?.trim() && doctorNameControl.value?.trim()) {
      return null;
    }


    const hospitalNameControl = control.get('hospitalName');

    if (doctorNameControl.value?.trim() && hospitalNameControl.value?.trim()) {
      return null;
    }

    return {
      InvalidPhysicianData: {
        InvalidPhysicianData: true
      }
    };
  }

  showRocheFields(): boolean {
    return this.companyId === PspCompanyEnum.Roche;
  }

  onRocheTypeChange(event: any): void {
    this.spinner.show();

    this.serialNumbersByType = [];

    this.enrollToAnotherProgramForm.patchValue({
      physicianDetails: {
        serialNumber: null,
        doctorName: null,
      }
    });

    if (this.rocheDoctors == null) {
      return;
    }

    for (const item of this.rocheDoctors) {
      if (item.code.find(e => e.toLowerCase() === event.toLowerCase())) {
        this.serialNumbersByType.push(item.serialNumber);
      }
    }

    // Remove duplicates
    this.serialNumbersByType = this.serialNumbersByType.filter(
      (item, index) => this.serialNumbersByType.indexOf(item) === index
    );

    this.serialNumbersByType.sort((a: string, b: string) => {
      return +a - +b; // Convert strings to numbers for numerical sorting
    });

    this.spinner.hide();
  }

  onDoctorSerialNumberChange(event: Event): void {
    this.enrollToAnotherProgramForm.patchValue({
      physicianDetails: {
        doctorName: null,
      }
    });

    if (this.enrollToAnotherProgramForm.get('physicianDetails.rocheType').value == null) {
      return;
    }

    if (this.enrollToAnotherProgramForm.get('physicianDetails.serialNumber').value == null) {
      return;
    }

    const doctor = this.rocheDoctors.find(item =>
      item.serialNumber === this.enrollToAnotherProgramForm.get('physicianDetails.serialNumber').value
      && item.code.find(c => c === this.enrollToAnotherProgramForm.get('physicianDetails.rocheType').value)
    );

    this.enrollToAnotherProgramForm.patchValue({
      physicianDetails: {
        doctorName: this.formatDoctorName(doctor),
      }
    });
  }

  preventWhiteSpace(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == ' ') {
      this.enrollToAnotherProgramForm.get('subscriptionHistory').reset();
    }
  }
  PreventWhiteSpaceAndNotifyWhenExceedMaxChars(event: KeyboardEvent): void {
    const cursorIndex: number = (event.target as HTMLInputElement).selectionStart;
    const subscriptionHistory = this.enrollToAnotherProgramForm.get('subscriptionHistory').value;
    this.displayErrorInSubscriptionHistory = false;
    const isAlphabetic = /^[a-zA-Z0-9\u0600-\u06FF\u0660-\u0669\u0670-\u06D3\u06D5\u06E5\u06E6!@#$%^&*()-_=+[\]{}|;:'",.<>/?\\`~\s]$/.test(event.key);
    const shortCuts = event.ctrlKey && (['a', 'c', 'x', 'z', 'v'].includes(event.key));

    if (event.key == ' ' && (subscriptionHistory == '' || subscriptionHistory == null
      || cursorIndex == 0)) {
      event.preventDefault();
    }

    else if (subscriptionHistory != null && subscriptionHistory.length >= 50
      && isAlphabetic && !shortCuts) {
      event.preventDefault();
      this.displayErrorInSubscriptionHistory = true;
    }

  }

  private hasCompanyPermission(companyId: number): boolean {
    switch (companyId) {
      case PspCompanyEnum.Eva:
        return IsPermissionExist(PspEvaPermission);
      case PspCompanyEnum.Lilly:
        return IsPermissionExist(PspLillyPermission);
      case PspCompanyEnum.Roche:
        return IsPermissionExist(PspRochePermission);
      default:
        return false;
    }
  }

  private formatDoctorName({ englishName, arabicName }): string {
    return [englishName, arabicName]
      .filter(name => name !== null && name !== undefined && name !== '')
      .join(' - ');
  }

  doctorNameChanged(doctorName: string): void {
    this.enrollToAnotherProgramForm.get('physicianDetails.doctorName').setValue(doctorName);
  }

  onChangeDoctorSpeciality(event: any): void {
    this.specialtyId = Number.parseInt(event);
    this.enrollToAnotherProgramForm.patchValue({
      physicianDetails: {
        doctorName: null,
      }
    });
  }

  onProgramChange(): void {
    this.enrollToAnotherProgramForm.get('referralCenterId').reset();
    this.enrollToAnotherProgramForm.get('referralCenterId').clearValidators();
    this.enrollToAnotherProgramForm.get('referralCenterId').enable();

    this.enrollToAnotherProgramForm.get('insulinTypeId').reset();
    this.enrollToAnotherProgramForm.get('insulinTypeId').clearValidators();
    this.enrollToAnotherProgramForm.get('insulinTypeId').enable();

    this.enrollToAnotherProgramForm.updateValueAndValidity();
    if (this.isInsulinProgramSelected()) {
      this.pspInsulinService
      .getInsulinCenters()
      .subscribe((res) => {
        this.referralCenters = res.data;
      });
    }
  }

  onFileUploaded(files: File[]) {
    for (let i = 0; i < files?.length; i++) {
      if (this.isFileValid(files[i])) {
        this.uploadedDocuments.push(files[i]);
      }
    }
  }

  isFileValid(file: File): boolean {
    let existingFileNames = this.uploadedDocuments?.map(e => e.name);
    const filesExtensions = this.uploadFileTypes.split(',').map(e => e.trim());
    const fileName = file.name.split('.');
    const fileExtension = fileName[fileName.length - 1];

    let maxDocumentsExceeded = this.uploadedDocuments.length >= this.maxDocumentsToUpload;
    if(maxDocumentsExceeded) {
      showNotification(
        'danger',
        `You can upload a maximum of ${this.maxDocumentsToUpload} files. Only the first ${this.maxDocumentsToUpload} files were added.`,
        this.toastr
      );
      return false;
    }

    let isFileNameExist = existingFileNames.find(e => e == file.name);
    if(isFileNameExist) {
      showNotification(
        'danger',
        `File ${file.name} is already added.`,
        this.toastr
      );
      return false;
    }

    let isValidExtension = filesExtensions.includes(`.${fileExtension.toLowerCase()}`);
    if(!isValidExtension) {
      showNotification(
        'danger',
        `File format is not supported. Only JPG, JPEG, PNG, GIF and PDF formats are allowed.`,
        this.toastr
      );
      return false;
    }

    return !isFileNameExist
      && !maxDocumentsExceeded
      && isValidExtension;
  }
  
  isInsulinProgramSelected(): boolean {
    const selectedProgramId = this.enrollToAnotherProgramForm.get('patientProgramId')?.value;
    const programName = this.programList?.find(e => e.id == selectedProgramId)?.name;

    return this.companyId === PspCompanyEnum.Eva && programName?.toLowerCase() == 'd-pen';
  }

  changeResponseToFormData(formValue): FormData {
    const formData = new FormData();
    formData.append('programId', formValue.patientProgramId || '');
    formData.append('pspTypeId', '1');
    formData.append('patientMobileNumber', formValue.patientMobileNumber || '');
    formData.append('patientFullName', formValue.patientFullName || '');
    formData.append('patientCityId', formValue.patientCityId || '');
    formData.append('patientAreaId', formValue.patientAreaId || '');
    formData.append('patientDOB', formValue.patientDateOfBirth || '');
    formData.append('patientNationalId', formValue.patientIds?.patientNationalId || '');
    formData.append('patientPassportId', formValue.patientIds?.patientPassportId || '');
    formData.append('subscriptionHistory', formValue.subscriptionHistory || '');
    formData.append('doctorName', formValue.physicianDetails.doctorName || '');
    formData.append('insulinTypeId', formValue.insulinTypeId || '');
    formData.append('InsulinCenterId', formValue.referralCenterId || '');

    if (this.companyId && this.companyId === PspCompanyEnum.Roche) {
      formData.append('doctorCode', `${formValue.physicianDetails.rocheType}-${formValue.physicianDetails.serialNumber}` || '');
    } else {
      formData.append('hospitalName', formValue.physicianDetails.hospitalName || '');
    }

    for (let i = 0; i < this.uploadedDocuments?.length; i++) {
      formData.append('Files', this.uploadedDocuments[i]);
    }
    return formData;
  }

  clearDocuments(): void {
    this.uploadedDocuments = [];
  }

  isFormInvalid(): boolean {
    if(this.enrollToAnotherProgramForm.invalid){
      return true;
    }

    if(!this.isInsulinProgramSelected()){
      return false;
    }

    if(this.enrollToAnotherProgramForm.get('referralCenterId').value 
      && this.enrollToAnotherProgramForm.get('insulinTypeId').value){
      return false;
    }
    
    return true;
  }
}
